import type { Ref } from 'vue'
import { computed } from 'vue'

import { IntegrationType, SessionIntegration, SyncType } from '@/graphql/types'

type LocalSession = {
  syncType: SyncType
  integrations: Pick<SessionIntegration, 'type' | 'syncedAt'>[]
}

function getIntegrationType(syncType: SyncType) {
  switch (syncType) {
    case SyncType.BC2:
      return IntegrationType.BC2
    case SyncType.BREADCRUMB:
      return IntegrationType.BREADCRUMB
    case SyncType.VAS:
      return IntegrationType.WEVE
    case SyncType.VAS_PLAY:
      return IntegrationType.PLAY
    case SyncType.WEVE_STANDARD:
    case SyncType.WEVE_MULTI_ROUND:
      return IntegrationType.WEVE
    case SyncType.PLAY:
      return IntegrationType.PLAY
  }
}

export default function useSessionSyncIntegration<T extends LocalSession>(
  session: Ref<T>,
) {
  const integration = computed(() => {
    const integrations = session.value.integrations
    const type = getIntegrationType(session.value.syncType)
    return integrations.find((i) => i.type === type)
  })
  return {
    integration,
  }
}
